import { gql } from '@apollo/client'

export default gql(`
    mutation adminSyncUser ( $userId: String! $project: String ) {
        adminSyncUser (
            userId: $userId
            project: $project
        ) {
            statusCode
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
